import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchKardex = (parameters, limit = 20, page = 0) => {
  const month = `&month=${parameters.month}`;
  const year = `&year=${parameters.year}`;
  const itemsCount = `&limit=${limit}`;
  const offset = `&offset=${page * limit}`;
  const allFilters = `${month}${year}${itemsCount}${offset}`;
  
  return apiActionCreator({
    'endpoint': `/parts/${parameters.code}/kardex/${parameters.warehouse}?${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_KARDEX,
      ActionTypes.FETCHED_KARDEX,
      [
        ActionTypes.FETCHED_KARDEX_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};


export const downloadKardex = (code, warehouseCode, filters) => apiActionCreator({
  'endpoint': `/parts/${code}/kardex/${warehouseCode}/excel?month=${filters.month}&year=${filters.year}`,
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOADING_KARDEX,
    ActionTypes.DOWNLOADED_KARDEX,
    [
      ActionTypes.DOWNLOADED_KARDEX_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
